"use strict";
/*
 * Created on 5. 3. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Family with leader product.
 * @author Radek Beran
 */


var FamilyWithLeader =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(FamilyWithLeader, _DomainObject_1$Domai);

  /**
   * Creates new family with leader product.
   * @param family family entity
   * @param leaderProductId id of product leader
   */
  function FamilyWithLeader(family, leaderProductId) {
    var _this;

    _classCallCheck(this, FamilyWithLeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FamilyWithLeader).call(this));
    _this.family = family;
    _this.leaderProductId = leaderProductId;
    return _this;
  }

  _createClass(FamilyWithLeader, [{
    key: "getBindingForLeader",
    value: function getBindingForLeader() {
      return this.leaderProductId !== null ? this.family.getBindingForProductId(this.leaderProductId) : null;
    }
  }]);

  return FamilyWithLeader;
}(DomainObject_1.DomainObject);

exports.FamilyWithLeader = FamilyWithLeader;